import { Navigate, useLocation } from "react-router-dom";
import { message } from "antd";

// Temporary Protected Route for testing purposes
// Uses separate variable (tempAuthToken) to not interfere with main login logic
const TempProtectedRoute = ({ children }) => {
  const location = useLocation();
  const tempAuthToken = localStorage.getItem("tempAuthToken");

  // Check if temporary token exists
  if (!tempAuthToken) {
    console.log("TempProtectedRoute - No temp auth token found");
    message.error("Please login to access this page");
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default TempProtectedRoute;

